export const Types = {
  setConfigs: 'config/SET_CONFIGS'
}

export function setConfigs ({ configs = {} } = {}) {
  return {
    type: Types.setConfigs,
    payload: { configs }
  }
}
